import styled from "@emotion/styled/macro";
import { PropsWithChildren, forwardRef } from "react";
import { IFrame } from "components/atoms/IFrame";

const AuthUi = styled.div<{ showAuth: boolean }>`
  visibility: ${({ showAuth }) => (showAuth ? "visible" : "hidden")};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

type AuthenticationProps = {
  basePath: string;
  src: string;
  title: string;
  showAuth: boolean;
  isLoaded: boolean;
};

const Authentication = forwardRef<
  HTMLIFrameElement,
  PropsWithChildren<AuthenticationProps>
>(({ children, basePath, src, title, showAuth, isLoaded }, ref) => {
  return (
    <>
      <AuthUi showAuth={showAuth}>
        <IFrame
          basePath={basePath}
          ref={ref}
          title={title}
          src={src}
          isAuth={true}
        ></IFrame>
      </AuthUi>
      {isLoaded && children}
    </>
  );
});

export { Authentication };
